import deriveUrlWithFragment from './derive-url-with-fragment';
import getIdentityQueryKey from "../api/identity/web-shell-client/get-query-key";
var getCheckoutHref = function getCheckoutHref() {
  var _queryClient$getQuery;
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    queryClient = _ref.queryClient,
    isLoggedInParam = _ref.isLoggedIn;
  var isClient = Boolean(typeof window !== 'undefined' && window.matchMedia);
  var isMobile = false;
  if (isClient && document.body) {
    var _window$matchMedia;
    var style = window.getComputedStyle(document.body);
    var mobileBreakpoint = style.getPropertyValue('--podium-cds-breakpoint-s');
    isMobile = (_window$matchMedia = window.matchMedia("(width <= ".concat(mobileBreakpoint, ")"))) === null || _window$matchMedia === void 0 ? void 0 : _window$matchMedia.matches;
  }

  // Prefer the explicit isLoggedIn param (from a React hook) over the sync cache read,
  // which can be stale or empty on pages that render the checkout button before identity loads.
  var isLoggedIn = typeof isLoggedInParam === 'boolean' ? isLoggedInParam : (_queryClient$getQuery = queryClient.getQueryData(getIdentityQueryKey())) === null || _queryClient$getQuery === void 0 ? void 0 : _queryClient$getQuery.isLoggedIn;
  var checkoutHref = deriveUrlWithFragment('checkout');
  return isLoggedIn || isMobile ? checkoutHref : "".concat(checkoutHref, "/tunnel");
};
export default getCheckoutHref;